
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },

  data() {
    return {
      isMounted: false,
      reviewOpen: false,
      activeReview: null,

      bgOptions: [
        {
          name: "whiteBg",
          label: this.$t("label.whiteBgCheckbox"),
          type: "checkbox",
        },
        {
          name: "subtitle",
          label: this.$t("label.boxForSubtitle"),
          type: "checkbox",
        },
      ],

      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "32x32",
        },
        {
          name: "name",
          label: this.$t("label.name"),
          type: "text",
        },
        {
          name: "position",
          label: this.$t("label.position"),
          type: "text",
        },
        {
          name: "rating",
          label: this.$t("label.rating"),
          type: "number",
        },
        {
          name: "quote",
          label: this.$t("label.quote"),
          type: "tipTap",
        },
      ],
      settings: {
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 860,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },

  mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, 500);
  },

  methods: {
    goToPrev(index) {
      if (this.$refs[`review_${index}`]) {
        this.$refs[`review_${index}`].prev();
      }
    },

    goToNext(index) {
      if (this.$refs[`review_${index}`]) {
        this.$refs[`review_${index}`].next();
      }
    },

    returnLinesCount(id) {
      if (!id || !this.isMounted) return;

      var lines = 0;
      var lineHeight = 24;
      var el = document.getElementById(id);

      if (el) {
        var divHeight = el.scrollHeight;
        lines = divHeight / lineHeight;
      }

      return lines;
    },

    openReviewModal(review) {
      this.reviewOpen = true;
      this.activeReview = review;
    },

    closeReviewModal() {
      this.reviewOpen = false;
      this.activeReview = null;
    },
  },
};
